import React from 'react';
import { useRevealAnimation } from '@/hooks/useRevealAnimation';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/cjs/styles/prism';

export const CodeBlock: React.FC<{
  code: string;
  language: string;
}> = ({ code, language }) => {
  const { ref, isVisible } = useRevealAnimation();

  return (
    <div
      ref={ref}
      className={`mb-6 rounded-lg overflow-hidden transform transition-all duration-700 ${
        isVisible
          ? 'translate-y-0 opacity-100 scale-100'
          : 'translate-y-4 opacity-0 scale-95'
      }`}
    >
      <SyntaxHighlighter
        language={language}
        style={vscDarkPlus}
        className="text-sm"
        showLineNumbers
        wrapLines
      >
        {code}
      </SyntaxHighlighter>
    </div>
  );
};
